














































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwForm, SwFormRow,  SwFormRowError } from '@libs-uuif/shared/sw-form';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { Prop } from 'vue-property-decorator';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import  { MswApiService } from '@/shared/msw-api-service';
import { required } from 'vuelidate/lib/validators';

const cssPrefix = 'add-affiliation';
@Component({
  components: {
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwForm,
    SwIcon,
    SwFormRow,
    SwFormRowError,
  },
  validations: {
    custId: { required },
    userGrp: { required },
    tenant: { required },
    access: { required },
  },
})
export default class AddAffiliation extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showAddAffiliation: boolean;

  custId: string = '';
  cusName: string = '';
  tenant: string[] = [];
  tenantOptions: SelectOption[] = [];
  userGrp: string = '';
  access: string = '--selectAccess--';
  accessOptions: any[] = [];

  getOrdInfo() {
    if (this.custId !== '') {
      this.$store.commit('startLoading');
      MswApiService.affiliations.getOrgInfoForAffiliaction(this.custId)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        console.warn(resp);
        this.tenantOptions = [];
        this.accessOptions = [
          {
            id: '--selectAccess--',
            value: '--selectAccess--',
            label: 'Select Access',
          },
        ];
        this.access = '--selectAccess--';
        this.tenant = [];
        this.userGrp = '';
        if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:SUCCESS') {
          this.cusName = resp?.content?.OrganizatonName;
          resp?.content?.Tenants.forEach((ele: any) => {
            const obj = {
              id: ele.productGroupId,
              value: ele.productGroupId,
              label: ele.TenantName,
            };
            this.tenantOptions.push(obj);
          });
          resp?.content?.access.forEach((ele: any) => {
            const obj = {
              id: ele.accessType,
              value: ele.accessType,
              label: ele.accessType,
            };
            this.accessOptions.push(obj);
          });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc || 'Something Went Wrong' });
        }
      });
    }
  }

  checkInputValidation(): boolean {
    this.$v!.custId!.$touch();
    this.$v!.tenant!.$touch();
    this.$v!.userGrp!.$touch();
    this.$v!.access!.$touch();
    if (!this.$v!.custId!.$invalid && !this.$v!.userGrp!.$invalid &&
        (this.custId != null && this.custId !== '') &&
        (this.userGrp != null && this.userGrp !== '') &&
        this.tenant.length !== 0 &&
        this.access !== '--selectAccess--') {
      return true;
    }
    return false;
  }

  get custIdTooltip(): TooltipDirValues {
    let content = '';
    content = String(this.$t('affiliation.add.custIdTT'));
    return {
      content,
      placement: 'bottom',
      compact: true,
      maxWidth: 275,
      includePopperForHover: true,
      doAnimation: true,
    };
  }

  get custNameTooltip(): TooltipDirValues {
    let content = '';
    content = String(this.$t('affiliation.add.custNameTT'));
    return {
      content,
      placement: 'bottom',
      compact: true,
      maxWidth: 275,
      includePopperForHover: true,
      doAnimation: true,
    };
  }

  get userGrpTooltip(): TooltipDirValues {
    let content = '';
    content = String(this.$t('affiliation.add.userGrpTT'));
    return {
      content,
      placement: 'bottom',
      compact: true,
      maxWidth: 275,
      includePopperForHover: true,
      doAnimation: true,
    };
  }

  submit() {
    console.warn(this.checkInputValidation());
    if (!this.checkInputValidation()) {
      return;
    }
    const tenantPayload = this.tenant.map((ele: any) => {
      return {
        productGroupId: ele,
      };
    });
    const req = {
      organizationID: this.custId,
      Tenants: tenantPayload,
      UserGroup: this.userGrp,
      accessType: this.access,
    };
    console.warn(req);
    this.$store.commit('startLoading');
    MswApiService.affiliations.addAffiliation(req)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.closeDialog(true);
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
    })
    .catch((err:any) => {
      console.error(err);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  closeDialog(val: boolean) {
    this.$emit('closeAddAffiliation', val);
  }

}
